import React from 'react';

import { MomentInput } from 'moment';
import { Task } from '@bringg/types';
import { DateDisplay } from '@bringg/react-components';
import { DEFAULT_DATE_FORMAT } from '@bringg-frontend/global-stores';

import { useStores } from 'bringg-web/recipes';
import { timezoneProvider } from 'bringg-web/services/timezone/timezone-provider';

const dateTimeFormat = (hourStringFormat: string): string => {
	return `${DEFAULT_DATE_FORMAT}, ${hourStringFormat}`;
};

const DateCell = ({ date, task }: { date: MomentInput; task: Task }) => {
	const {
		merchantConfigurationsStore: { hourStringFormat }
	} = useStores();
	const timezone = timezoneProvider.getTimezoneByTask(task);

	return (
		<DateDisplay
			date={date}
			format={dateTimeFormat(hourStringFormat)}
			timezone={timezone}
			invalidDateText="-- : --"
		/>
	);
};

export default DateCell;
